import React from "react";

// Components
import Cookies from 'universal-cookie';
import getCorso from "../../services/getCorso";
import getValutazioniCorso from "../../services/getValutazioniCorso";
import getEsami from "../../services/getEsami";
import getStudenti from "../../services/getStudenti";
import moment from 'moment';
import { PDFViewer, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import translateString from "../../utils/Locales";
import getMaterie from '../../services/getMaterie';

let t = translateString;

export default class PdfExam extends React.Component {

  constructor(props){
    super (props)
    this.state = {
      grades: [], 
      isReadyToShow: false
    };
  }

  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentCorso = cookies.get('currentCourse', { path: '/' });
    const requestedExam = cookies.get('selectedExam', { path: '/' });

    this.logoUrl = window.sessionStorage.getItem('logo');

    this.corso = await getCorso(username, token, currentCorso);
    this.valutazioni = await getValutazioniCorso(username, token, this.corso.id);
    this.esami = await getEsami(username, token, this.corso.id);
    this.studenti = await getStudenti(username, token);
    this.materie = await getMaterie(username, token);
    this.studenti = this.studenti.filter(s => s.corsi.includes(this.corso.id+";") && s.corsi_ritiro.indexOf(this.corso.id+';') == -1);
    this.exam = this.esami.filter((esame) => esame.id == requestedExam)[0];

    this.studenti.sort((s1, s2) => { return (s1.cognome).localeCompare(s2.cognome) });

    var grades = [];
    var mainGrades = [];
    var ind = 0;

    this.studenti.forEach((studente) => {

        var nota = [];
        const esameStudente = this.valutazioni.filter((esame) => esame.id_studente == studente.id && esame.id_esame == requestedExam)[0];
        nota.push(studente.cognome.toUpperCase() + ' ' + studente.nome.toUpperCase());
        nota.push((esameStudente == null || !esameStudente['valutazione'] || esameStudente.valutazione == '-1') ? 'N/A' : esameStudente.valutazione);
        grades.push(nota);
        if (grades.length == 15 || ind == this.studenti.length - 1) {
          mainGrades.push(grades);
          grades = [];
        }
        ind++;
    });

    this.setState({ grades: grades, isReadyToShow: true, main: mainGrades, totalPages: mainGrades.length });
  }

  render () {

    const timeNow = moment().format('yyyy-MM-DD HH:mm:ss'); 

    return (
        <div style={{width: '100%', height: '100%'}} key={Math.random()} > 
        { this.state.isReadyToShow && (
            <PDFViewer style={{width: '100%', height: '100%'}}>
                <Document>
                  { this.state.main.map((gruppo, index) => {

                      if (index == 0) {
                        return (
                            <Page size="A4" style={{paddingTop: 80, paddingBottom: 50}} orientation="portrait" wrap>
                                <View style={{ marginTop: -60 }}>
                                    <Image style={{position: 'absolute', top: 30, left: 40, width: 'auto', height: 80}} src={ this.logoUrl ? this.logoUrl : require('../../images/icon.png')} />
                                    <Text style={{position: 'absolute', top: 45, right: 30, fontSize: 12, width: '100%', textAlign: 'right', color: '#999999'}}>{timeNow}</Text>
                                    <Text style={{margin: 10, fontSize: 20, width: '100%', textAlign: 'center', marginTop: '100px'}}>{t('valutazioni')}</Text>
                                    <Text style={{fontSize: 14, marginLeft: 10, marginRight: 10, maxHeight: 80, width: '100%', textAlign: 'center', marginTop: '5px', color: '#999999', paddingHorizontal: 40}}>{this.materie.find(m => m.id === this.exam.id_materia).materia} {this.exam.nome} {this.exam.data}</Text>
                                    <View style={styles.page} >
                                        <View style={styles.row}>
                                              <View style={{...styles.columnLeft, textAlign: 'center'}}><Text>{t('studente').toUpperCase()}</Text></View>
                                              <View style={{...styles.columnRight, textAlign: 'center'}}><Text>{t('valutazione').toUpperCase()}</Text></View>
                                        </View>
                                        { gruppo.map((voto) => {
                                            return(
                                              <View style={{...styles.row, marginTop: -1}}>
                                                  <View style={styles.columnLeft}><Text style={{alignItems: 'center', flex:1}}>{voto[0]}</Text></View>
                                                  <View style={styles.columnRight}><Text style={{alignItems: 'center', flex:1}}>{voto[1]}</Text></View>
                                              </View>
                                            );
                                        })}
                                    </View>
                                  </View>
                                  <View style={{ position: 'absolute', bottom: 50, left: 0, width: '100%', backgroundColor: '#FFFFFF', textAlign: 'right' }}><Text style={{fontWeight: 'light', fontSize: 9, color: '#BDBDBD', marginRight: 50}}>{t('pagina')} {index + 1} {t('di')} {this.state.totalPages}</Text></View>
                            </Page>
                        );
                      } else {

                        return(
                          <Page size="A4" style={{paddingTop: 80, paddingBottom: 50}} orientation="portrait" wrap>
                              <View style={{ marginTop: -30 }}>
                                  <View style={styles.page} >
                                      <View style={styles.row}>
                                            <View style={{...styles.columnLeft, textAlign: 'center'}}><Text>{t('studente').toUpperCase()}</Text></View>
                                            <View style={{...styles.columnRight, textAlign: 'center'}}><Text>{t('valutazione').toUpperCase()}</Text></View>
                                      </View>
                                      { gruppo.map((voto) => {
                                          return(
                                            <View style={{...styles.row, marginTop: -1}}>
                                                <View style={styles.columnLeft}><Text style={{alignItems: 'center', flex:1}}>{voto[0]}</Text></View>
                                                <View style={styles.columnRight}><Text style={{alignItems: 'center', flex:1}}>{voto[1]}</Text></View>
                                            </View>
                                          );
                                      })}
                                  </View>
                                </View>
                                <View style={{ position: 'absolute', bottom: 50, left: 0, width: '100%', backgroundColor: '#FFFFFF', textAlign: 'right' }}><Text style={{fontWeight: 'light', fontSize: 9, color: '#BDBDBD', marginRight: 50}}>{t('pagina')} {index + 1} {t('di')} {this.state.totalPages}</Text></View>
                          </Page>
                        );
                      }
                  })}
                    
                </Document>
            </PDFViewer> 
        )}
        </div>
    );
  }
}

const styles = StyleSheet.create({
  
  row: {
    flexDirection: 'row',
    display: 'flex',
    border:'1 solid #000',
    width: '90%',
    marginLeft: '5%', 
    minHeight: '30px',
  },

  page: {
    fontSize: 10,
    backgroundColor: '#ffffff',
    padding: 10, 
    marginTop: '20px'
  },

  columnLeft: {
    flexDirection: 'column',
    width: '50%',
    borderRight: '1 solid #000', 
    textAlign: 'left', 
    paddingHorizontal: 30, 
    paddingVertical: 10, 
    flex: 1
  }, 

  columnRight: {
    flexDirection: 'column',
    textAlign: 'center', 
    paddingHorizontal: 30, 
    paddingVertical: 10, 
    flex: 1
  }

});
